/* Per-animal collection pages (sve-col-*).
   Filter: two filters, one active at a time, "goal" (collections, bestsellers, single products) and "product type"
   (the product groups of sve-col-shelves). Cards carry data-goals=" c<collection id> … p<product id> g<group block id> ".
   Both filters live in <details> blocks that open and close: open by default on desktop, dropdowns on phones.
   ?goal=c<id>&type=g<id> in the URL opens the page filtered.
   Also: quick add for one-size products, dots under swipeable rows, sticky offset under the site header.
   Older pages may still have goal tiles (sve-col-goals) with data-sve-col-goal: they drive the same goal filter. */
(function () {
  if (window.sveColFilter) return;
  window.sveColFilter = true;

  var state = { goal: '', type: '', animal: '' };
  var desk = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : { matches: true };

  function list() { return document.querySelector('[data-sve-col-filter]'); }
  function has(card, key) { return (card.getAttribute('data-goals') || '').indexOf(' ' + key + ' ') !== -1; }
  function labelOf(attr, key) {
    var el = key ? document.querySelector('[' + attr + '="' + key + '"]') : null;
    return el ? el.getAttribute('data-label') || '' : '';
  }

  /* Hide filter options (and goal tiles) without products on this page; update tile counts */
  function recount() {
    var l = list();
    if (!l) return;
    var cards = l.querySelectorAll('.sve-col-card');
    /* the daily basis (ESTE / food) is in every goal; it doesn't count to show a goal */
    function count(key) {
      var n = 0;
      cards.forEach(function (c) { if (has(c, key) && !c.closest('.sve-col-shelf.is-basis')) n++; });
      return n;
    }
    /* small collections (4 products or fewer): no filter column */
    l.classList.toggle('no-filter', cards.length <= 4);
    /* goal collections (e.g. "Skin and coat"): the goal filter is not needed */
    var gdd = l.querySelector('[data-sve-col-dd="goal"]');
    if (gdd) gdd.hidden = !!l.getAttribute('data-auto-goal');
    var grid = document.querySelector('[data-sve-col-goals]');
    var many = grid ? grid.getAttribute('data-count-label') || '' : '';
    var one = grid ? grid.getAttribute('data-count-one') || many : '';
    document.querySelectorAll('[data-sve-col-goal], [data-sve-col-type]').forEach(function (o) {
      var n = count(o.getAttribute('data-sve-col-goal') || o.getAttribute('data-sve-col-type'));
      o.toggleAttribute('data-empty', n === 0);
      o.hidden = n === 0;
      var c = o.querySelector('[data-count]');
      if (c && many) c.textContent = (n === 1 ? one : many).replace('[n]', n);
    });
  }

  function setCounts(l) {
    l.querySelectorAll('.sve-col-shelf').forEach(function (g) {
      var n = g.querySelectorAll('.sve-col-card:not([hidden])').length;
      g.hidden = n === 0;
      var s = g.querySelector('[data-n]');
      if (s) { s.textContent = n; s.hidden = n < 3; }
    });
    tiers(l);
  }

  /* Goal-specific "why" lines from the menu texts, shown above the description (both stay visible, Valerie 2026-10-21) */
  var why = null;
  function whyLines(l, g) {
    if (why === null) {
      try { why = JSON.parse((l.querySelector('[data-sve-col-why]') || {}).textContent || '{}'); } catch (e) { why = {}; }
    }
    l.querySelectorAll('.sve-col-card').forEach(function (c) {
      var w = c.querySelector('.sve-col-card__why');
      if (!w) return;
      var txt = g ? why[g + '|' + c.getAttribute('data-pid')] || '' : '';
      /* no repeat when the goal line says the same as the short line in the band */
      var tag = c.querySelector('.sve-col-card__tag');
      if (tag && txt && tag.textContent.trim().toLowerCase().indexOf(txt.trim().toLowerCase()) === 0) txt = '';
      w.textContent = txt;
      w.hidden = !txt;
    });
  }

  /* Per-goal product order (same setting format as the menu): listed products first */
  function goalOrder(l, g) {
    var order = [];
    (l.getAttribute('data-goal-order') || '').split(';').forEach(function (line) {
      var parts = line.split(':');
      if (g && parts.length === 2 && parts[0].trim() === g) order = parts[1].split(',').map(function (x) { return x.trim(); });
    });
    l.querySelectorAll('.sve-col-card').forEach(function (c) {
      var i = order.indexOf(c.getAttribute('data-pid'));
      c.style.order = order.length ? (i > -1 ? i : 100) : '';
    });
  }

  /* Level labels ("Foundation", "Targeted support"): only on the first visible group of each level */
  function tiers(l) {
    var seen = {};
    l.querySelectorAll('.sve-col-shelf').forEach(function (g) {
      var lab = g.querySelector('.sve-col-shelf__tier');
      if (!lab) return;
      var k = g.getAttribute('data-tier');
      lab.hidden = !!seen[k] || g.hidden;
      if (!g.hidden) seen[k] = true;
    });
  }

  /* Animal filter (mixed collections like "All"): goals only show for the chosen animal */
  function goalVisibility(l) {
    var a = state.animal, any = false;
    document.querySelectorAll('[data-sve-col-goal][data-animal]').forEach(function (o) {
      var show = !o.hasAttribute('data-empty') && !!a && o.getAttribute('data-animal') === a;
      o.hidden = !show;
      if (show) any = true;
    });
    var hint = l.querySelector('[data-goal-hint]');
    if (hint) hint.hidden = any || !!a;
    /* names per animal (e.g. "Balancer and food" → "Dog food", "Fitness and care" → "Care") */
    l.querySelectorAll('[data-names]').forEach(function (el) {
      var map = {};
      try { map = JSON.parse(el.getAttribute('data-names')); } catch (e) {}
      var base = el.hasAttribute('data-sve-col-type') ? el.getAttribute('data-label-base') || el.getAttribute('data-label') : el.getAttribute('data-title');
      if (el.hasAttribute('data-sve-col-type') && !el.hasAttribute('data-label-base')) el.setAttribute('data-label-base', base);
      var txt = (a && map[a]) || base;
      if (el.hasAttribute('data-sve-col-type')) { el.setAttribute('data-label', txt); el.textContent = txt; }
      else el.textContent = txt;
    });
        /* product types: only the ones that exist for the chosen animal (e.g. no Snacks for horses) */
    if (l.querySelector('[data-sve-col-animal]')) {
      var cards = l.querySelectorAll('.sve-col-card');
      document.querySelectorAll('[data-sve-col-type]').forEach(function (o) {
        var k = o.getAttribute('data-sve-col-type'), n = 0;
        cards.forEach(function (c) { if (has(c, k) && (!a || has(c, a))) n++; });
        o.hidden = n === 0;
      });
      if (state.type) {
        var cur = document.querySelector('[data-sve-col-type="' + state.type + '"]');
        if (cur && cur.hidden) state.type = '';
      }
    }
  }

  function apply(scroll) {
    var l = list();
    if (!l) return;
    var g = state.goal, t = state.type, an = state.animal;
    var auto = l.getAttribute('data-auto-goal') || '';
    /* The daily basis (Balancer / food) always stays visible for a goal, like in the menu */
    l.querySelectorAll('.sve-col-card').forEach(function (c) {
      var basis = !!c.closest('.sve-col-shelf.is-basis');
      c.hidden = !!((g && !basis && !has(c, g)) || (t && !has(c, t)) || (an && !has(c, an)));
    });
    /* Companions (e.g. dosage cup with the Balancer): visible whenever their main product is */
    l.querySelectorAll('.sve-col-card[data-with]').forEach(function (c) {
      if (!c.hidden) return;
      var main = l.querySelector('.sve-col-card[data-goals*=" ' + c.getAttribute('data-with') + ' "]');
      if (main && !main.hidden && (!t || has(c, t) || main.closest('.sve-col-shelf') === c.closest('.sve-col-shelf'))) c.hidden = false;
    });
    /* On a goal collection (e.g. "Skin and coat") its own goal labels show without choosing anything */
    whyLines(l, g || auto);
    goalOrder(l, g || auto);
    goalVisibility(l);
    setCounts(l);
    var on = !!(g || t || an);
    var sp = l.querySelector('[data-special]');
    if (sp) sp.hidden = !g || sp.getAttribute('data-special') !== g;
    l.classList.toggle('is-filtered', on);
    compact();

    document.querySelectorAll('[data-sve-col-goal]').forEach(function (o) { o.setAttribute('aria-pressed', g && o.getAttribute('data-sve-col-goal') === g ? 'true' : 'false'); });
    document.querySelectorAll('[data-sve-col-type]').forEach(function (o) { o.setAttribute('aria-pressed', t && o.getAttribute('data-sve-col-type') === t ? 'true' : 'false'); });
    document.querySelectorAll('[data-sve-col-all]').forEach(function (o) { o.setAttribute('aria-pressed', g ? 'false' : 'true'); });
    document.querySelectorAll('[data-sve-col-type-all]').forEach(function (o) { o.setAttribute('aria-pressed', t ? 'false' : 'true'); });
    document.querySelectorAll('[data-sve-col-animal]').forEach(function (o) { o.setAttribute('aria-pressed', an && o.getAttribute('data-sve-col-animal') === an ? 'true' : 'false'); });
    document.querySelectorAll('[data-sve-col-animal-all]').forEach(function (o) { o.setAttribute('aria-pressed', an ? 'false' : 'true'); });

    var gl = labelOf('data-sve-col-goal', g), tl = labelOf('data-sve-col-type', t), al = labelOf('data-sve-col-animal', an);
    var dds = l.querySelectorAll('[data-sve-col-dd]');
    var ddVal = function (name, txt) {
      var d = l.querySelector('[data-sve-col-dd="' + name + '"]');
      var v = d && d.querySelector('[data-dd-val]');
      if (v) v.textContent = txt;
    };
    ddVal('goal', gl); ddVal('type', tl); ddVal('animal', al);

    var bar = l.querySelector('[data-sve-col-active]');
    if (bar) {
      bar.hidden = !on;
      var b = bar.querySelector('[data-label]');
      if (b) b.textContent = [al, gl, tl].filter(Boolean).join(' · ');
      var bc = bar.querySelector('[data-count]');
      if (bc) bc.textContent = l.querySelectorAll('.sve-col-card:not([hidden])').length;
    }

    try {
      var u = new URL(window.location.href);
      if (g) u.searchParams.set('goal', g); else u.searchParams.delete('goal');
      if (t) u.searchParams.set('type', t); else u.searchParams.delete('type');
      if (an) u.searchParams.set('animal', an); else u.searchParams.delete('animal');
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}

    /* Phones: close the dropdown after a choice */
    if (!desk.matches) dds.forEach(function (d) { d.open = false; });

    if (scroll) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = (on && bar) ? bar : l;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  }

  /* Quick add for one-size products: same flow as the theme's product form (refresh + open the cart drawer) */
  function quickAdd(btn) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.classList.add('is-busy');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-sve-col-add')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      var mc = window.Alpine && Alpine.store && Alpine.store('xMiniCart');
      if (mc) {
        mc.reLoad();
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        if (typeof mc.openCart === 'function') mc.openCart();
      } else {
        window.location.href = root + 'cart';
      }
    }).catch(function () {
      var a = btn.closest('.sve-col-card').querySelector('a[href]');
      if (a) window.location.href = a.href;
    }).then(function () { btn.classList.remove('is-busy'); });
  }

  /* Dots under swipeable rows on phones */
  function dots() {
    document.querySelectorAll('.sve-col-shelf__row:not(.is-grid)').forEach(function (row) {
      if (row.nextElementSibling && row.nextElementSibling.classList.contains('sve-col-dots')) return;
      if (row.children.length < 2) return;
      var d = document.createElement('div');
      d.className = 'sve-col-dots';
      d.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < row.children.length; i++) d.appendChild(document.createElement('span'));
      row.parentNode.insertBefore(d, row.nextSibling);
      function upd() {
        var first = row.children[0];
        var w = first ? first.getBoundingClientRect().width + 12 : 1;
        var on = Math.round(row.scrollLeft / w);
        Array.prototype.forEach.call(d.children, function (s, j) { s.classList.toggle('is-on', j === on); });
      }
      row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  /* Keep the sticky filter just below the sticky site header */
  function setTop() {
    var top = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (h) {
      var pos = getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') top = Math.max(top, Math.round(h.getBoundingClientRect().bottom));
    });
    document.documentElement.style.setProperty('--sve-col-top', top + 'px');
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; setTop(); });
  }, { passive: true });
  window.addEventListener('resize', setTop);

  /* Filters open on desktop, closed (dropdowns) on phones */
  function setOpen() {
    document.querySelectorAll('[data-sve-col-dd]').forEach(function (d) { d.open = !!desk.matches; });
  }
  if (desk.addEventListener) desk.addEventListener('change', setOpen);

  /* ── Quick buy panel (Valerie 2026-10-21, like Hers) ──
     Size + one-time / "Subscribe and save" with frequency, then add to cart and open the cart drawer.
     Plans = the card's JSON (juo-selling-plans-json 'live', same as the live PDP subscription widget),
     filtered to the variant's allocations and de-duplicated by name, exactly like that widget. */
  var qbEl = null, qbData = null, qbState = null, qbLastFocus = null;
  function qbLabels() {
    var t = document.querySelector('template[data-sve-col-qb-labels]');
    var d = function (k, f) { return (t && t.getAttribute('data-' + k)) || f; };
    return { size: d('size', 'Size'), once: d('once', 'One-time purchase'), sub: d('sub', 'Subscribe and save'),
      freq: d('freq', 'Delivery'), add: d('add', 'Add to cart'), more: d('more', 'Learn more'), close: d('close', 'Close') };
  }
  /* Same money format as the rest of the shop (theme setting, e.g. "€{{amount_with_comma_separator}}") */
  function money(cents) {
    var fmt = (window.KROWN && KROWN.settings && KROWN.settings.shop_money_format) || '€{{amount_with_comma_separator}}';
    var n = (Number(cents) / 100).toFixed(2);
    var parts = n.split('.');
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_with_comma_separator') return dot;
      if (k === 'amount_no_decimals') return parts[0];
      if (k === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return comma;
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function plansFor(v) {
    var ids = (v.allocations || []).map(function (a) { return Number(a.plan); });
    var seen = {};
    return (qbData.plans || []).filter(function (p) {
      if (ids.indexOf(Number(p.id)) === -1) return false;
      var k = String(p.name || '').trim().toLowerCase();
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    });
  }
  function planLabel(p) { return String(p.name || '').split('|')[0].trim(); }
  function planOff(p) {
    var a = p.price_adjustments && p.price_adjustments[0];
    return a && a.value_type === 'percentage' ? a.value : null;
  }
  function slug(s) { return String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function qbRender() {
    var L = qbLabels(), d = qbData, s = qbState;
    var v = d.variants.filter(function (x) { return x.id === s.variant; })[0] || d.variants[0];
    var plans = plansFor(v);
    if (!plans.some(function (p) { return Number(p.id) === Number(s.plan); })) {
      var pop = plans.filter(function (p) { return v.popular && slug(p.name) === v.popular; })[0];
      s.plan = plans.length ? (pop || plans[0]).id : null;
    }
    if (!plans.length) s.sub = false;
    var alloc = (v.allocations || []).filter(function (a) { return Number(a.plan) === Number(s.plan); })[0];
    var subPrice = alloc ? alloc.price : v.price;
    var off = plans.length ? planOff(plans[0]) : null;
    var h = '<div class="sve-col-qb__box" role="dialog" aria-modal="true" aria-label="' + esc(d.title) + '">';
    h += '<button type="button" class="sve-col-qb__x" data-qb-close aria-label="' + esc(L.close) + '">×</button>';
    h += '<div class="sve-col-qb__head">' + (d.image ? '<img src="' + esc(d.image) + '" alt="" width="64" height="64">' : '') + '<p class="sve-col-qb__t">' + esc(d.title) + '</p></div>';
    if (d.variants.length > 1 && d.options && d.options.length > 1) {
      /* several options (e.g. dog food: bag size × life stage): one row of choices per option, like the PDP */
      d.options.forEach(function (opt, oi) {
        h += '<p class="sve-col-qb__lbl">' + esc(opt.name) + '</p><div class="sve-col-qb__sizes">';
        opt.values.forEach(function (val) {
          var sel = v.options[oi] === val;
          var any = d.variants.some(function (x) { return x.options[oi] === val && x.available; });
          h += '<button type="button" class="sve-col-qb__size" data-qb-opt="' + oi + '" data-qb-val="' + esc(val) + '" aria-pressed="' + sel + '"' + (any ? '' : ' disabled') + '>' + esc(val) + '</button>';
        });
        h += '</div>';
      });
    } else if (d.variants.length > 1) {
      h += '<p class="sve-col-qb__lbl">' + esc(L.size) + '</p><div class="sve-col-qb__sizes">';
      d.variants.forEach(function (x) {
        h += '<button type="button" class="sve-col-qb__size" data-qb-variant="' + x.id + '" aria-pressed="' + (x.id === v.id) + '"' + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '<small>' + money(x.price) + '</small></button>';
      });
      h += '</div>';
    }
    h += '<div class="sve-col-qb__opts">';
    h += '<label class="sve-col-qb__opt"><input type="radio" name="sve-col-qb-type" value="once"' + (s.sub ? '' : ' checked') + '><span>' + esc(L.once) + '</span><b>' + money(v.price) + '</b></label>';
    if (plans.length) {
      h += '<label class="sve-col-qb__opt"><input type="radio" name="sve-col-qb-type" value="sub"' + (s.sub ? ' checked' : '') + '><span>' + esc(L.sub) + (off ? ' <em>−' + off + '%</em>' : '') + '</span><b>' + money(subPrice) + (subPrice < v.price ? ' <s>' + money(v.price) + '</s>' : '') + '</b></label>';
      if (s.sub) {
        h += '<label class="sve-col-qb__freq"><span>' + esc(L.freq) + '</span><select data-qb-plan>';
        plans.forEach(function (p) { h += '<option value="' + p.id + '"' + (Number(p.id) === Number(s.plan) ? ' selected' : '') + '>' + esc(planLabel(p)) + '</option>'; });
        h += '</select></label>';
      }
    }
    h += '</div>';
    h += '<button type="button" class="sve-col-qb__add" data-qb-add' + (v.available ? '' : ' disabled') + '>' + esc(L.add) + ' · ' + money(s.sub ? subPrice : v.price) + '</button>';
    h += '<a class="sve-col-qb__more" href="' + esc(d.url) + '">' + esc(L.more) + ' →</a>';
    h += '</div>';
    qbEl.innerHTML = h;
  }
  function qbOpen(btn) {
    var card = btn.closest('.sve-col-card');
    var js = card && card.querySelector('[data-sve-col-qb-data]');
    if (!js) return;
    try { qbData = JSON.parse(js.textContent); } catch (e) { window.location.href = card.querySelector('a[href]').href; return; }
    qbState = { variant: qbData.defaultVariant, sub: false, plan: null };
    if (!qbEl) {
      qbEl = document.createElement('div');
      qbEl.className = 'sve-col sve-col-qb';
      document.body.appendChild(qbEl);
    }
    qbLastFocus = btn;
    qbRender();
    qbEl.hidden = false;
    document.documentElement.classList.add('sve-col-qb-open');
    var first = qbEl.querySelector('button, input, select');
    if (first) first.focus();
  }
  function qbClose() {
    if (!qbEl || qbEl.hidden) return;
    qbEl.hidden = true;
    document.documentElement.classList.remove('sve-col-qb-open');
    if (qbLastFocus) qbLastFocus.focus();
  }
  function qbAdd(btn) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var item = { id: Number(qbState.variant), quantity: 1 };
    if (qbState.sub && qbState.plan) item.selling_plan = Number(qbState.plan);
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        qbClose();
        var mc = window.Alpine && Alpine.store && Alpine.store('xMiniCart');
        if (mc) {
          mc.reLoad();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          if (typeof mc.openCart === 'function') mc.openCart();
        } else { window.location.href = root + 'cart'; }
      })
      .catch(function () { btn.disabled = false; window.location.href = qbData.url; });
  }
  document.addEventListener('click', function (e) {
    if (!qbEl || qbEl.hidden || !qbEl.contains(e.target)) return;
    if (e.target === qbEl || e.target.closest('[data-qb-close]')) { qbClose(); return; }
    var vb = e.target.closest('[data-qb-variant]');
    if (vb) { qbState.variant = Number(vb.getAttribute('data-qb-variant')); qbRender(); return; }
    var ob = e.target.closest('[data-qb-opt]');
    if (ob) {
      var oi = Number(ob.getAttribute('data-qb-opt')), val = ob.getAttribute('data-qb-val');
      var cur = qbData.variants.filter(function (x) { return x.id === qbState.variant; })[0] || qbData.variants[0];
      var want = cur.options.slice(); want[oi] = val;
      var match = qbData.variants.filter(function (x) { return x.options.every(function (o, i) { return o === want[i]; }); })[0];
      if (!match || !match.available) match = qbData.variants.filter(function (x) { return x.options[oi] === val && x.available; })[0] || match;
      if (match) { qbState.variant = match.id; qbRender(); }
      return;
    }
    var ab = e.target.closest('[data-qb-add]');
    if (ab) { qbAdd(ab); }
  });
  document.addEventListener('change', function (e) {
    if (!qbEl || !qbEl.contains(e.target)) return;
    if (e.target.name === 'sve-col-qb-type') { qbState.sub = e.target.value === 'sub'; qbRender(); var r = qbEl.querySelector('input[value="' + e.target.value + '"]'); if (r) r.focus(); }
    if (e.target.hasAttribute('data-qb-plan')) { qbState.plan = Number(e.target.value); qbRender(); var sel = qbEl.querySelector('[data-qb-plan]'); if (sel) sel.focus(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') qbClose(); });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-sve-col-add]');
    if (q) { e.preventDefault(); quickAdd(q); return; }
    var qo = e.target.closest('[data-sve-col-qb]');
    if (qo) { e.preventDefault(); qbOpen(qo); return; }
    var o = e.target.closest('[data-sve-col-goal]');
    if (o) {
      var k = o.getAttribute('data-sve-col-goal');
      state.goal = state.goal === k ? '' : k;
      /* One filter at a time: a goal resets the product type (Valerie 2026-10-21) */
      if (state.goal) state.type = '';
      apply(true);
      return;
    }
    var ty = e.target.closest('[data-sve-col-type]');
    if (ty) {
      var tk = ty.getAttribute('data-sve-col-type');
      state.type = state.type === tk ? '' : tk;
      /* One filter at a time: a product type shows ALL products of that type (Valerie 2026-10-21) */
      if (state.type) state.goal = '';
      apply(true);
      return;
    }
    var ao = e.target.closest('[data-sve-col-animal]');
    if (ao) {
      var ak = ao.getAttribute('data-sve-col-animal');
      state.animal = state.animal === ak ? '' : ak;
      /* a goal of another animal no longer applies */
      var gOpt = state.goal && document.querySelector('[data-sve-col-goal="' + state.goal + '"][data-animal]');
      if (gOpt && gOpt.getAttribute('data-animal') !== state.animal) state.goal = '';
      goalVisibility(list());
      apply(true);
      return;
    }
    if (e.target.closest('[data-sve-col-animal-all]')) {
      state.animal = '';
      if (document.querySelector('[data-sve-col-goal="' + state.goal + '"][data-animal]')) state.goal = '';
      apply(true);
      return;
    }
    if (e.target.closest('[data-sve-col-all]')) { state.goal = ''; apply(true); return; }
    if (e.target.closest('[data-sve-col-type-all]')) { state.type = ''; apply(true); return; }
    var c = e.target.closest('[data-sve-col-clear]');
    if (c && list()) {
      e.preventDefault();
      state.goal = ''; state.type = ''; state.animal = '';
      apply(true);
      return;
    }
    /* Phones: tapping outside an open dropdown closes it */
    if (!desk.matches && !e.target.closest('[data-sve-col-dd]')) {
      document.querySelectorAll('[data-sve-col-dd][open]').forEach(function (d) { d.open = false; });
    }
  });

  /* Phones: only one dropdown open at a time */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (desk.matches || !d.matches || !d.matches('[data-sve-col-dd]') || !d.open) return;
    document.querySelectorAll('[data-sve-col-dd][open]').forEach(function (x) { if (x !== d) x.open = false; });
  }, true);

  function clean(v) { return (v || '').replace(/[^a-z0-9]/gi, ''); }
  /* Groups with few products sit next to each other instead of one under the other, whenever two neighbouring
     groups fit on one line together (Valerie 2026-10-22, e.g. Hoof health with 2 products). Card widths stay the
     same as the normal grid: the number of columns and the gap are read from the grid itself. Off while filtering. */
  function compact() {
    document.querySelectorAll('.sve-col-shelves__groups').forEach(function (g) {
      g.classList.remove('is-compact');
      evenOut(g);
      var sec = g.closest('.sve-col-shelves');
      /* phones: groups stay under each other, side by side the two titles read as one (Valerie 2026-10-22) */
      if ((sec && sec.classList.contains('is-filtered')) || window.innerWidth < 768) return;
      var shelves = [].slice.call(g.querySelectorAll('.sve-col-shelf')).filter(function (s) { return !s.hidden && s.offsetParent; });
      if (shelves.length < 2) return;
      /* an empty probe row tells how many columns a full row has here (rows of 1-2 cards are capped by is-n1/is-n2) */
      var probe = document.createElement('div');
      probe.className = 'sve-col-shelf__row';
      probe.style.visibility = 'hidden';
      shelves[0].appendChild(probe);
      var cs = getComputedStyle(probe);
      var cols = cs.display === 'grid' && cs.gridTemplateColumns !== 'none' ? cs.gridTemplateColumns.split(' ').filter(Boolean).length : 0;
      var gap = parseFloat(cs.columnGap) || 10;
      probe.remove();
      if (cols < 2) return;
      var ns = shelves.map(function (s) {
        var r = s.querySelector('.sve-col-shelf__row');
        return r ? [].filter.call(r.children, function (c) { return !c.hidden; }).length : 0;
      });
      var fits = false;
      for (var i = 0; i < ns.length - 1; i++) if (ns[i] && ns[i + 1] && ns[i] + ns[i + 1] <= cols) fits = true;
      if (!fits) return;
      shelves.forEach(function (s, i) { s.style.setProperty('--n', Math.max(1, Math.min(ns[i], cols))); });
      g.style.setProperty('--cols', cols);
      g.style.setProperty('--cg', gap + 'px');
      g.classList.add('is-compact');
      evenOut(g);
    });
  }
  /* Side-by-side groups: every card starts at the same height and is the same size (Valerie 2026-10-22) */
  function evenOut(g) {
    var shelves = [].slice.call(g.querySelectorAll('.sve-col-shelf'));
    shelves.forEach(function (s) {
      var r = s.querySelector('.sve-col-shelf__row');
      if (r) r.style.marginTop = '';
      [].forEach.call(s.querySelectorAll('.sve-col-card'), function (c) { c.style.minHeight = ''; });
    });
    if (!g.classList.contains('is-compact')) return;
    var lines = {};
    shelves.forEach(function (s) {
      if (s.hidden || !s.offsetParent) return;
      var k = Math.round(s.offsetTop);
      (lines[k] = lines[k] || []).push(s);
    });
    Object.keys(lines).forEach(function (k) {
      var line = lines[k], head = 0, card = 0;
      line.forEach(function (s) {
        var r = s.querySelector('.sve-col-shelf__row');
        if (r) head = Math.max(head, r.getBoundingClientRect().top - s.getBoundingClientRect().top);
        [].forEach.call(s.querySelectorAll('.sve-col-card:not(.sve-col-card--mini)'), function (c) { if (!c.hidden) card = Math.max(card, c.getBoundingClientRect().height); });
      });
      line.forEach(function (s) {
        var r = s.querySelector('.sve-col-shelf__row');
        if (r) r.style.marginTop = (head - (r.getBoundingClientRect().top - s.getBoundingClientRect().top)) + 'px';
        [].forEach.call(s.querySelectorAll('.sve-col-card:not(.sve-col-card--mini)'), function (c) { c.style.minHeight = card + 'px'; });
      });
    });
  }
  function init() {
    recount();
    compact();
    if (list()) tiers(list());
    setOpen();
    setTop();
    dots();
    var u = null;
    try { u = new URL(window.location.href); } catch (e) {}
    if (u) state.animal = clean(u.searchParams.get('animal'));
    if (u && (u.searchParams.get('goal') || u.searchParams.get('type'))) {
      state.goal = clean(u.searchParams.get('goal'));
      state.type = state.goal ? '' : clean(u.searchParams.get('type'));
      apply(true);
    } else if (list()) {
      /* no filter in the URL: still apply once (goal labels on goal collections, animal hint, ?animal=) */
      apply(!!state.animal);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { recount(); setOpen(); dots(); compact(); });
  var compactT;
  window.addEventListener('resize', function () { clearTimeout(compactT); compactT = setTimeout(compact, 150); });
  /* photos and the Trustpilot stars change card heights after load */
  window.addEventListener('load', function () { compact(); setTimeout(compact, 1500); });
})();
